<template>
   <el-tabs type="border-card">
        <el-tab-pane label="新增友链">
            <div style="margin-top:16px;" >
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="友链名称">
                        <el-input v-model.trim="form.name" placeholder="友链名称"></el-input>
                    </el-form-item>
                    <el-form-item label="友链地址">
                        <el-input v-model.trim="form.url" placeholder="友链地址"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">立即创建</el-button>
                        <el-button @click="onCancel">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
  export default {
    data() {
      return {
        form: {
          name: '',
          url: '',
          token: this.user.getToken()
        },
      }
    },

    methods: {
      onSubmit() {
        // 初始化默认加载菜单
        this.http.post(
          '/skip/add', 
          this.form, res => {
            if (res.success) {
              // 返回正确的处理
              this.$router.push("/skip/list")
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
        });
      },
      onCancel() {
          this.$router.go(-1)
      }
    },
    mounted() {
    }
  }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/views/skip/skipAdd.vue